// Português do Brasil

export default {
    'About': 'Sobre',
    'Company': 'Empresa',
    'Contact': 'Contato',
    'Email Address': 'Endereço de e-mail',
    'First Name': 'Nome',
    'Get In Touch': 'Entrar em contato',
    'Manage Cookies': 'Gerenciar cookies',
    'Media Kit': 'Mídia kit',
    'Newsroom': 'Notícias',
    'Password': 'Senha',
    'Privacy Policy': 'Política de privacidade',
    'Related Case Studies': 'Estudos de caso relacionados',
    'Related Resources': 'Recursos relacionados',
    'See Case Study': 'Ver o estudo de caso',
    'Sign up': 'Inscreva-se',
    'Submit': 'Enviar',
    'The Goal': 'A meta',
    'View All': 'Ver tudo',
    'You are missing one or more requred fields': 'Faltam um ou mais campos obrigatórios',
    'All resources': 'Todos os recursos',
    'All case studies': 'Todos os estudos de caso',
    'All articles': 'Todos os artigos',
    'Do Not Share My Personal Information': 'Não compartilhar minhas informações pessoais',
};
